module.exports = __webpack_public_path__ + "static/zh-logo100-web-black-11f124f684f3f9d73ac2507668488581.svg";